import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.links && _vm.links.length)?_c('links',{attrs:{"artist":_vm.artist,"email":_vm.email,"phoneNumber":_vm.phoneNumber}}):_vm._e(),_c('div',{staticClass:"text-center"},[_c(VBtn,{staticClass:"mb-8",attrs:{"large":"","color":'rgba(0,0,0,0.4)'},on:{"click":function($event){return _vm.$emit('complete')}}},[_vm._v(" "+_vm._s(this.homepageParameters.linksButton || 'Continue')+" ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }